import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "time",
  "use": "time-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"time\"><defs><style>#time .cls-1{fill-rule:evenodd}</style></defs><title>接入中</title><g id=\"time_画板\"><path id=\"time_接入中\" class=\"cls-1\" d=\"M6 0a6 6 0 1 1-6 6 6 6 0 0 1 6-6zm-.62 3.05a.45.45 0 0 0-.45.45v3.56a.45.45 0 0 0 .23.32l3 1.52h.08a.45.45 0 0 0 .53-.23V8.6a.45.45 0 0 0-.23-.53L5.83 6.7V3.42a.45.45 0 0 0-.45-.37z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/time.svg
// module id = vsvj
// module chunks = 6